var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/application/environment",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mt5dayuaua"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/environment (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/environment (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/environment",
    style: {
      clipPath: "url(#mt5dayuaua)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/environment (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/environment (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.995 16.82a.767.767 0 0 1-.39-.107 15.733 15.733 0 0 1-3.312-2.69 11.613 11.613 0 0 1-1.951-2.778 8.294 8.294 0 0 1-.881-3.667 6.24 6.24 0 0 1 .517-2.5 6.368 6.368 0 0 1 1.4-2.034 6.65 6.65 0 0 1 7.162-1.366 6.487 6.487 0 0 1 2.078 1.37 6.341 6.341 0 0 1 1.4 2.034 6.24 6.24 0 0 1 .517 2.5 8.237 8.237 0 0 1-.884 3.667 11.566 11.566 0 0 1-1.951 2.779 15.729 15.729 0 0 1-3.312 2.69.772.772 0 0 1-.394.107zM9 2.444a5.315 5.315 0 0 0-3.734 1.508 5.04 5.04 0 0 0-1.539 3.626 8 8 0 0 0 2.2 5.262 14.724 14.724 0 0 0 3.071 2.633c1.237-.786 5.274-3.677 5.274-7.894a5.031 5.031 0 0 0-1.54-3.625A5.309 5.309 0 0 0 9 2.444zm0 8.367a3.094 3.094 0 1 1 3.094-3.094A3.1 3.1 0 0 1 9 10.811zm0-5.063a1.969 1.969 0 0 0 0 3.937h.005a1.943 1.943 0 0 0 .749-.149A1.969 1.969 0 0 0 9 5.748z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutlined);
export default __webpack_public_path__ + "static/media/location_outlined.0a8ff04c5872d2a60b318c4656b3fd9f.svg";
export { ForwardRef as ReactComponent };